/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ModuleManifest } from "shared/bootstrap";
import store from "./store";
import publicLocale from "./i18n/public.json";

const manifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "my-projects" },
      title: "projectsupload.menuItems.myProjects",
      icon: "project-diagram",
      hideNoAuth: true,
    },
  ],
  routes: [
    {
      path: "/mijn-projecten",
      name: "my-projects",
      meta: {
        auth: true,
        title: "projectsupload.menuItems.myProjects",
      },
      component: () => import("./pages/MyProjects.vue"),
    },
    {
      path: "/mijn-projecten/:id",
      name: "my-project",
      meta: {
        auth: true,
        title: "projectsupload.menuItems.myProjects",
      },
      component: () => import("./pages/Project.vue"),
    },
  ],
  storeModules: {
    projectsupload: store,
  },
  widgets: [
    {
      name: "ProjectInfo",
      component: () => import("./widgets/ProjectInfo.vue"),
    },
    {
      name: "SubscriptionInfo",
      component: () => import("./widgets/SubscriptionInfo.vue"),
    },
  ],
  localisation: { key: "projectsupload", messages: publicLocale },
};

export default manifest;
